import { Component, Host, h, Prop, Element, State } from '@stencil/core';

@Component({
    tag: 'sew-ws-stage-item',
    styleUrl: 'sew-ws-stage-item.scss',
    shadow: false,
})
export class SewWsStageItem {
    @Element() el: HTMLSewWsStageItemElement;

    @Prop() topicLine: string;
    @Prop() headline: string;
    @Prop({ reflect: true }) index: number;
    @Prop({ reflect: true }) compact = false;
    @Prop({ reflect: true }) duration: string;

    /**
     * controls if video has autoplay
     */
    @Prop({ reflect: true }) autoplay = false;
    @Prop() videoTitle: string;

    @Prop() imageAlign = 'center';

    @State() hasLink: boolean;
    @State() hasVideo = false;
    @State() hasChild = false;

    componentWillLoad(): void {
        this.hasLink = !!this.el.querySelector('a');
        const videoElement = this.el.querySelector('sew-video');
        this.hasVideo = !!videoElement;
        this.hasChild = !!this.el.querySelector('div');

        if (this.hasVideo) {
            videoElement.classList.add('inside-stage');
        }

        if (this.duration) {
            this.el.style.setProperty('--stage-image-animation-time', this.duration + 'ms');
        }

        // set object-fit for image
        const sewPicture = this.el.querySelector('sew-picture');
        if (sewPicture) {
            sewPicture.objectFit = true;
        }
    }

    render() {
        const stageTeaserClasses = {
            'stage-teaser': true,
            'compact': this.compact,
        };

        return (
            <Host class={{ 'splide__slide': true, 'is-video': this.hasVideo }}>
                {!this.hasVideo && (
                    <div class="image-wrapper" style={{ 'justify-content': this.imageAlign }}>
                        <slot name="picture"></slot>
                    </div>
                )}
                {this.hasVideo && (
                    <div class="video-wrapper">
                        <slot name="video"></slot>
                    </div>
                )}
                {this.headline && (
                    <div class={stageTeaserClasses}>
                        <div class="topic-line">{this.topicLine}</div>
                        {this.index === 0 && <h1 class="headline" innerHTML={this.headline}></h1>}
                        {this.index !== 0 && <h2 class="headline" innerHTML={this.headline}></h2>}
                        {this.hasLink && (
                            <div class="link">
                                <sew-icon class="svg" icon="arrow-east" />
                                <slot></slot>
                            </div>
                        )}
                        {this.compact && this.hasChild && (
                            <div class="slotted">
                                <slot></slot>
                            </div>
                        )}
                    </div>
                )}
            </Host>
        );
    }
}
